import { Divider, Stack } from '@mui/material';

import { Text, api } from 'common';

import { BlockDurationField } from '../../../ConfigFields/Duration';
import { FilterAndSortBlockFormFields } from '../FilterAndSortFormFields';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const EncountersVariant = {
  schema: PatientDataStore.EncountersConfigSchema,
  Config: () => {
    return (
      <Stack spacing={2}>
        <Text variant="heading5" bold>
          Encounter Filters
        </Text>
        <BlockDurationField
          fieldName="config.encounterFilters.lookbackDuration"
          toggleLabel="Filter by Encounter date"
          valueLabel="Only fetch encounters within last"
          unitFieldNameSuffix="units"
          required={false}
          allowedUnits={[...PatientDataStore.DURATION_UNIT_OPTIONS]}
        />
        <Divider sx={{ marginY: 2 }} />
        <FilterAndSortBlockFormFields />
      </Stack>
    );
  },
};
